module.exports = __webpack_public_path__ + "static/og-image-2edcbb948c1aa28649abfc61a9771f10.jpg";